import React from 'react';

/**
 * Renders a pack name with the size letter (S, M, L, XL) highlighted in flash green.
 * Supports both "Pack S - DJ Booth" and "Pack XL - Premium" formats.
 */
export const PackName = ({ name, className = '' }) => {
  if (!name) return null;
  const match = name.match(/^(Pack\s)(S|M|L|XL)(.*)$/);
  if (!match) return <span className={className}>{name}</span>;
  return (
    <span className={className}>
      {match[1]}
      <span className="text-[#9aae00]" style={{ textShadow: '0 0 8px rgba(154,174,0,0.4)' }}>{match[2]}</span>
      {match[3]}
    </span>
  );
};
